export default __webpack_public_path__ + "static/media/four.b5ffe9e6.png";